import React from 'react';
import { Section, Divider } from './ui/Section';
import { Sparkles } from 'lucide-react';
export function UniqueMechanism() {
  return <Section data-id="element-154">
      <div className="max-w-4xl mx-auto text-center" data-id="element-155">
        <div className="inline-flex items-center justify-center space-x-2 mb-6" data-id="element-156">
          <Sparkles className="w-5 h-5 text-gold" data-id="element-157" />
          <span className="text-sm tracking-widest uppercase text-gold-dark font-semibold" data-id="element-158">
            El Nuevo Paradigma
          </span>
          <Sparkles className="w-5 h-5 text-gold" data-id="element-159" />
        </div>

        <h2 className="text-3xl md:text-5xl font-serif mb-8 text-navy" data-id="element-160">
          Presentamos el método de la <br data-id="element-161" />
          <span className="italic text-gold-dark" data-id="element-162">"Presencia Silenciosa"</span>
        </h2>

        <div className="text-lg text-charcoal-light font-light leading-relaxed space-y-6 text-left md:text-center max-w-3xl mx-auto" data-id="element-163">
          <p data-id="element-164">
            Inspirado en la estética{' '}
            <strong className="font-medium text-navy" data-id="element-165">Old Money</strong> y la
            psicología de la autoridad, este sistema no te enseña a ser una
            "influencer", sino a ser una{' '}
            <strong className="font-medium text-navy" data-id="element-166">
              Figura de Autoridad
            </strong>
            .
          </p>
          <p data-id="element-167">
            Aprendes a dominar la luz, el encuadre y el lenguaje para que tu
            experiencia hable antes de que tú abras la boca.
          </p>
          <p className="text-xl font-serif text-navy mt-8 p-8 bg-cream-dark/50 rounded-sm border border-gold/20" data-id="element-168">
            "Es el arte de atraer mediante la elegancia y la solidez,
            convirtiendo tu edad en tu ventaja competitiva más cara."
          </p>
        </div>
      </div>
    </Section>;
}